import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { TruckLocationModel } from "./models";

export type ListTruckLocationsRequest = {
  eventDate: Date;
};

export type ListTruckLocationsResponse = {
  truckLocations: TruckLocationModel[];
};

export const listTruckLocations = async (request: ListTruckLocationsRequest) => {
  const options = {
    params: {
      eventDate: request.eventDate
    }
  };
  const response = await executeApiRequest(() => axios.get<ListTruckLocationsResponse>("/trucklocations", options), false);
  return response?.data;
};
